import { render, staticRenderFns } from "./Itemrow.vue?vue&type=template&id=b483a3c2"
import script from "./Itemrow.vue?vue&type=script&lang=js"
export * from "./Itemrow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports